import { BASE_URL } from '../BASE_URL';

export const getDesigners = async () => {
  const response = await fetch(BASE_URL + 'brands/designers/', {
    method: 'GET',
  });
  const data = await response.json();
  return data;
};
